import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export const BuyEnergyCore = ({ copied, sequence }) => {
  const ref = useRef(null);
  const inView = useInView(ref);
  const [visible, setVisible] = useState(() => !document.hidden);
  useEffect(() => {
    const update = () => setVisible(!document.hidden);
    document.addEventListener("visibilitychange", update);
    return () => document.removeEventListener("visibilitychange", update);
  }, []);
  return (
    <div ref={ref} className="buy-energy" aria-hidden="true" data-testid="buy-energy-core" data-running={inView && visible}>
      <svg viewBox="0 0 700 380" className="buy-energy__hud" focusable="false">
        <ellipse cx="350" cy="190" rx="280" ry="145" className="buy-energy__orbit" pathLength="100" />
        <ellipse cx="350" cy="190" rx="245" ry="126" className="buy-energy__orbit buy-energy__orbit--inner" pathLength="100" />
        <path d="M20 190H122 M578 190H680 M350 8V45 M350 335V372" className="buy-energy__axes" />
      </svg>
      <span className="buy-energy__scan" />
      {[0, 1, 2, 3, 4, 5].map((i) => <i key={i} className="buy-energy__particle" style={{ "--particle": i }} />)}
      {copied && <span key={sequence} className="buy-energy__copy-pulse" data-testid="buy-copy-energy-pulse" />}
    </div>
  );
};